import React from "react";

export default function Hand(props) {
  return (
    <img src={props.image} alt="ERROR" width="110" height="150" ></img>
  )
}
